module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/default-banner-ultimate-f0208f1232ff03e01e90a13fcc423afc.png";